module.exports = __webpack_public_path__ + "img/portadaNuevaMobile2.b0bd93de.webp";